export default __webpack_public_path__ + "static/media/BSI-InstallationLarge.0fbf4416.jpg";